import styles from './DocumentListSection.scss?inline';

import {BaseContainer} from "../../base/customComponent/BaseContainer";

class DocumentListSection extends BaseContainer {
    constructor() {
        super();
        this.customStyle = styles;
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(
            `text-card-section`,
        );
        container.innerHTML = `
            <header></header>
            <div class="section-body">
                <div class="document-lists">
                    <slot></slot>
                </div>
                <div class="cta"></div>
            </div>
      `;
        // Clone Slots into container to prevent styling issues
        container.querySelector('header').append(this.createHeader('horizontal'));
        this.cloneSlotContentIntoContainer(container.querySelector('.cta'), 'cta');
        return container;
    }

}

customElements.define('nxt-document-list-section', DocumentListSection);
